/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.CollectionsRpc
 */

export const AppCollectionItemsTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.AppCollectionItems';
export const AppCollectionItemsDiscriminant = 'APP';
export const AppCollectionItemsDiscriminantKey = 'productType';
export const CollectionErrorDiscriminantKey = 'type';
export const CollectionItemsDiscriminantKey = 'productType';
export const CollectionNotFoundErrorTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.CollectionNotFoundError';
export const CollectionNotFoundErrorDiscriminant = 'COLLECTION_NOT_FOUND';
export const CollectionNotFoundErrorDiscriminantKey = 'type';
export const ModuleCollectionItemsTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.ModuleCollectionItems';
export const ModuleCollectionItemsDiscriminant = 'MODULE';
export const ModuleCollectionItemsDiscriminantKey = 'productType';
export const ThemeCollectionItemsTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.ThemeCollectionItems';
export const ThemeCollectionItemsDiscriminant = 'THEME';
export const ThemeCollectionItemsDiscriminantKey = 'productType';
export const UnknownProductTypeErrorTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.UnknownProductTypeError';
export const UnknownProductTypeErrorDiscriminant = 'UNKNOWN_PRODUCT_TYPE';
export const UnknownProductTypeErrorDiscriminantKey = 'type';
export const UnsupportedProductTypeErrorTypename = 'com.hubspot.marketplace.quality.models.rpcs.collections.UnsupportedProductTypeError';
export const UnsupportedProductTypeErrorDiscriminant = 'UNSUPPORTED_PRODUCT_TYPE';
export const UnsupportedProductTypeErrorDiscriminantKey = 'type';
export const getRelevantPublishedIdsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.CollectionsRpc',
  rpcName: 'getRelevantPublishedIds',
  auth: 'app',
  fingerprint: '930u9a0XP0HL6Im6rBloohKHfXazHxIe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getItemsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.CollectionsRpc',
  rpcName: 'getItems',
  auth: 'app',
  fingerprint: '530g2uqN44hkHxodrJoiwhKHfXazHxIe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCollectionsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.CollectionsRpc',
  rpcName: 'getCollections',
  auth: 'app',
  fingerprint: 'By7BhwSrcxShIYKWkl_kHRKHfXazHxIe',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};